import { getUserData } from "@/auth/getUserData";
import { resolveAutomaticSignature } from "@/utils/channels";
import useReplies from "@/composables/v2.1/useReplies";

export default function chatTransformer(chat) {
    const { activeReply } = useReplies();

    const transformToOutboundEntry = (chatEntryInput, attachments, { isTemplate, isQuickReply, selectedTemplate }) => {
        let chatEntry = {
            channelId: chat.channel.id,
            identityId: chat.identity.id,
            payload: {
                conversation: {
                    id: chat.lastConversation.id,
                },
                from: {
                    provider: chat.channel.provider,
                    platform: chat.channel.platform,
                    identity: chat.channel.identity,
                    user: {
                        id: chat.assignee?.id ?? getUserData().id,
                    },
                },
                to: {
                    provider: chat.channel.provider,
                    platform: chat.channel.platform,
                    identity: chat.identity.identity,
                },
                metadata: {
                    replyToMessageId: activeReply.value?.id,
                },
            },
        };

        if (!isTemplate && !isQuickReply) {
            chatEntry.extras = {
                displayName: getUserData().displayName,
            };
        }

        if (chat.channel.platform === "email") {
            let metadata = null;

            if (chatEntryInput.metadata) {
                metadata = {
                    subject: chatEntryInput.metadata.subject,
                    externalReference: chatEntryInput.metadata.externalReference,
                    to: chatEntryInput.metadata.to?.map((email) => ({
                        emailAddress: email,
                    })),
                    cc: chatEntryInput.metadata.cc?.map((email) => ({
                        emailAddress: email,
                    })),
                    bcc: chatEntryInput.metadata.bcc?.map((email) => ({
                        emailAddress: email,
                    })),
                };
            }

            chatEntry.payload = {
                ...chatEntry.payload,
                metadata,
            };
        }

        return {
            ...chatEntry,
            payload: {
                ...chatEntry.payload,
                content: getContent(chatEntryInput, attachments, { isTemplate, isQuickReply, selectedTemplate }),
            },
        };
    };

    const resolveEntryType = (chatEntryInput, attachments) => {
        if (attachments?.length > 0) {
            return "asset";
        }

        return "text";
    };

    const getContent = (chatEntryInput, attachments, { isTemplate, isQuickReply, selectedTemplate }) => {
        let message = chatEntryInput.message;

        if (
            !isTemplate &&
            !isQuickReply &&
            message // Don't append automatic signature if there is no text in the first place (like with just assets)
        ) {
            message = resolveAutomaticSignature(message, chat.channel);
        }

        const content = {
            text: message,
            template: selectedTemplate?.id ? { id: selectedTemplate.id } : isTemplate,
        };

        if (attachments?.length > 0) {
            content.attachments = attachments.map((attachment) => ({
                category: attachment.category,
                type: "buffer",
                payload: `${process.env.VUE_APP_FRONTEND_ASSET_ENDPOINT}/${attachment.filePath}/${attachment.fileName}`,
                contentType: attachment.contentType,
                originalName: attachment.originalName || attachment.fileName, // Nice-attachment.png
                filePath: attachment.filePath, // ss-prod-xxx/sent/image/20220/original/png/
                fileName: attachment.fileName, // 34n4l14kyx22vae.png
            }));
        }

        return content;
    };

    return {
        transformToOutboundEntry,
        resolveEntryType,
    };
}
